import mountVueOnPage from '../mount_vue'
import NewFriendRequestModal from '../new_friend_request_modal.vue'

// One app for the whole profile page (mount_vue owns the lifecycle): the
// friend-request modal, plus the item wardrobe. Items search and paging swap
// in place, but the URL carries items_q / items_page the whole time, so
// copied links and the back button land on the same page of the same search.

let onPopState = null

mountVueOnPage('users', 'show', {
    data() {
        const params = new URLSearchParams(window.location.search)
        return {
            show_modal: false,
            search_open: !!params.get('items_q'),
            q: params.get('items_q') || '',
            appliedQ: params.get('items_q') || '',
            page: parseInt(params.get('items_page'), 10) || 1,
            page_count: 1,
            total: 0,
            purchases: [],
            loading: true,
        }
    },
    components: {
        'new-friend-modal': NewFriendRequestModal,
    },
    // mounted, not created: Vue empties the container before it builds the
    // component, so during created() the profile markup (and its data
    // attributes) is not in the document yet.
    async mounted() {
        this.itemsUrl = document.getElementById('profile-items-app')?.dataset.itemsUrl
        if (!this.itemsUrl) return
        await this.fetchItems(false)
        onPopState = async () => {
            const params = new URLSearchParams(window.location.search)
            this.q = params.get('items_q') || ''
            this.search_open = !!this.q
            this.page = parseInt(params.get('items_page'), 10) || 1
            await this.fetchItems(false)
        }
        window.addEventListener('popstate', onPopState)
    },
    unmounted() {
        if (onPopState) { window.removeEventListener('popstate', onPopState); onPopState = null }
    },
    methods: {
        async searchNow() {
            clearTimeout(this.searchTimer)
            this.page = 1
            await this.fetchItems(true)
        },
        // The cap toggles the box: open slides the input out and focuses it.
        toggleSearch() {
            if (this.search_open) {
                this.search_open = false
                return
            }
            this.search_open = true
            this.$nextTick(() => this.$refs.itemsSearch?.focus())
        },
        // Same live search as the store: debounced per keystroke.
        debouncedSearch() {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => this.searchNow(), 200)
        },
        // Deselecting the box slides it away (the results stay as they are).
        // Focus moving onto the cap is the toggle's own click - let it decide.
        onSearchBlur(e) {
            if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.head-search')) return
            this.search_open = false
        },
        // Esc: put the wardrobe back how it was and tuck the box away.
        async dismissSearch() {
            this.search_open = false
            const hadSearch = !!this.appliedQ
            this.q = ''
            if (hadSearch) await this.searchNow()
        },
        async goToPage(n) {
            this.page = n
            await this.fetchItems(true)
        },
        async fetchItems(updateUrl) {
            this.loading = true
            const { data } = await axios.get(`${this.itemsUrl}.json`, {
                params: {
                    items_q: this.q || undefined,
                    items_page: this.page > 1 ? this.page : undefined,
                },
            })
            this.loading = false
            this.total = data.total
            this.page = data.page
            this.page_count = data.page_count
            this.purchases = data.purchases
            this.appliedQ = this.q
            if (updateUrl) this.syncUrl()
        },
        // Only non-default values go in the URL: a fresh profile link stays clean.
        syncUrl() {
            const params = new URLSearchParams(window.location.search)
            params.delete('items_q')
            params.delete('items_page')
            if (this.q) params.set('items_q', this.q)
            if (this.page > 1) params.set('items_page', String(this.page))
            const query = params.toString()
            history.pushState({}, '', window.location.pathname + (query ? `?${query}` : '') + '#items')
        },
    },
})
